import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ApiService from '../util/ApiService';
import {Form} from 'react-bootstrap';
import Swal from 'sweetalert2';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./assets/css/Contact.css";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import {Tag} from "antd"; // Importa o idioma PT-BR

const ContactDetailModal = ({show, onHide, contact = {}}) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        'message': '',
        'contact_id': ''
    });

    useEffect(() => {
        if (contact) {
            setFormData({
                message: '',
                contact_id: contact.id
            });
        } else {
            setFormData({
                message: '',
                contact_id: ''
            });
        }
    }, [contact]);

    const handleSave = async () => {
        try {
            setLoading(true);

            const response = await ApiService.send(
                'post',
                `${process.env.REACT_APP_URL_API}contact/message/register`,
                formData,
                true
            );

            if (response?.code === 200) {

                const {data} = ApiService.handleApiResponse(response);


                const protocolId = data.contact_id;
                Swal.fire({
                    title: "Sucesso!",
                    text: `Atualizado Protocolo: #${protocolId}`,
                    icon: "success",
                    confirmButtonText: "OK",
                }).then(() => {
                    onHide(true);
                });
            } else {
                throw new Error(response?.message || 'Erro ao salvar resposta.');
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>Detalhes do Contato</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="contact-details">
                    <ul className="list-group mb-3">
                        <p>
                            <strong>Nome:</strong> {contact.name}
                        </p>
                        <div className="d-flex align-items-center mb-2">
                            {contact.status && <Tag color="blue">{contact.status.name}</Tag>}
                            {contact.priority && <Tag color="red">{contact.priority.name}</Tag>}
                        </div>
                        <div className="row">
                            <div className="col col-12">
                                <strong>Email:</strong> {contact.email}
                            </div>
                            <div className="col col-12">
                                <strong>Data de Criação:</strong> {dayjs(contact.created_at).format("DD/MM/YYYY HH:mm")}
                            </div>
                        </div>
                        <p>
                            <strong>Assunto:</strong> {contact.subject}
                        </p>
                        <p>
                            <strong>Questionamento:</strong> <span dangerouslySetInnerHTML={{__html: contact.message}}/>
                        </p>
                    </ul>

                    <h6 className="mb-2">Mensagens:</h6>
                    <div style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        marginBottom: "15px",
                        border: "1px solid #ddd",
                        padding: "10px",
                        borderRadius: "5px"
                    }}>
                        {contact.messages?.length > 0 ? (
                            <ul className="list-group">
                                {contact.messages.map((msg) => (
                                    <li key={msg.id} className="list-group-item text-sm">
                                        <strong>{msg.user_name}</strong>:  <span dangerouslySetInnerHTML={{__html:msg.message}}/>
                                        <span className="text-muted ms-2" style={{fontSize: "12px"}}>
                                            {msg.created_at ? dayjs(msg.created_at).format("DD/MM/YYYY HH:mm") : "Data não disponível"}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <div className="alert alert-primary" role="alert">Nenhuma mensagem disponível.</div>
                        )}
                    </div>

                    <h6>Responder:</h6>
                    <ReactQuill
                        theme="snow"
                        value={formData.message || ""}
                        onChange={(content) => setFormData({...formData, message: content})}
                        placeholder="Digite a resposta..."
                        className="custom-quill mb-3"
                        modules={{
                            toolbar: [
                                [{header: [1, 2, false]}],
                                ["bold", "italic", "underline"],
                                [{list: "ordered"}, {list: "bullet"}],
                                ["link"],
                                ["clean"]
                            ],
                        }}
                        formats={[
                            "header", "bold", "italic", "underline",
                            "list", "bullet", "link", "image"
                        ]}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary"  onClick={() =>onHide()}>
                   <i className="fa fa-close"></i> Cancelar
                </Button>
                <Button variant="primary" onClick={() =>handleSave()} disabled={loading}>
                    {loading ? (
                        <>
                    <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                    ></span>
                            Enviando...
                        </>
                    ) : (
                        <>
                            <i className="fa fa-plus me-1"></i> Enviar Resposta
                        </>
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ContactDetailModal;
